import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M19.987 4.614a.5.5 0 0 0-.698-.567l-15 7a.5.5 0 0 0-.013.9L8 13.81v3.69a.5.5 0 0 0 .82.384l2.65-2.208 4.176 4.178a.5.5 0 0 0 .84-.24zm-8.85 10.038L9 16.432v-2.695l7.524-6.156z"
}), 'SendFilled');
//# sourceMappingURL=index.js.map